import styled from 'styled-components';

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
